export type WixPatternsErrorCode =
  | 'GetExportAsyncJob.offline'
  | 'GetExportAsyncJob.invalid'
  | 'GetExportAsyncJob.failed'
  | 'SaveViewFailed'
  | 'RenameViewFailed'
  | 'DeleteViewFailed'
  | 'LoadCustomFieldsWidgetLazyContentFailed'
  | 'InitCustomFieldsDataExtensionFailed'
  | 'InitCustomFieldsWidgetContainerFailed'
  | 'SetAsDefaultViewFailed'
  | 'DataExtensionInitFailed'
  | 'GetTagsFailed'
  | 'CreateTagFailed'
  | 'UpdateTagFailed'
  | 'RemoveTagFailed'
  | 'BulkAssignTagsFailed';
